import React from "react";
import { motion } from "framer-motion";
import { useCertificates } from "../dashboard/useCertificates";
import { ColorRing } from "react-loader-spinner";
import Certificate from "../homeData/Certificate";

const Certificates = () => {
  const { certificates, isLoading, error } = useCertificates();

  if (isLoading) {
    return (
      <div className="flex justify-center py-10">
        <ColorRing
          visible={true}
          height="80"
          width="80"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          colors={["#ff014f", "#ff014f", "#ff014f", "#ff014f", "#ff014f"]}
        />
      </div>
    );
  }

  if (error) return <div className="text-center text-red-500">Error loading certificates</div>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20 pb-20"
    >
      <div className="w-full">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-700 dark:text-gray-300">Certificates</h2>
        </div>
        <div className="mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
            {certificates?.map((cert) => (
              <div key={cert.id} className="w-full h-full">
                 <div className="w-full h-full"> 
                     {/* Reuse the component from Home Data for exact match */}
                     {/* We import it at the top */}
                     {/* However, the Resume page design might need the title displayed below the card if not in the card. 
                         The shared component DOES NOT display the title text (h3). 
                         If the user wants EXACT match, we use the component. 
                         Let's confirm if we need to display title. 
                         The previous Resume page had titles. The Home page doesn't. 
                         But the uploaded image for Resume page showed titles. 
                         Use the inline code I just wrote? No, user said "style... implement same like the home page".
                         Home page = Certificate.jsx (no title).
                         I will use Certificate.jsx but ADD a title below it if needed, or modify Certificate.jsx to optionally show title.
                         Actually, let's modify Certificate.jsx to accept 'showTitle' or just render title if passed? 
                         But Certificate.jsx structure is fixed.
                         I will wrap Certificate in a div and put title below it if desired, or just use Certificate as is. 
                         For now, I'll use Certificate component directly. */}
                      {/* Can't import relative easily if paths differ significantly. 
                          I'll import it from relative path. 
                          Path: ../../component/homeData/Certificate
                       */}
                      <Certificate
                        title={cert.title}
                        image={cert.image}
                        verificationUrl={cert.verificationUrl}
                        pdf={cert.pdf}
                      />
                      <h3 className="mt-4 text-center text-lg font-semibold text-gray-700 dark:text-gray-300">
                        {cert.title}
                      </h3>
                 </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Certificates;
